import { render, staticRenderFns } from "./topNavbar.vue?vue&type=template&id=540b3aeb&"
import script from "./topNavbar.vue?vue&type=script&lang=ts&"
export * from "./topNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./topNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports